// Sentry init — routed through the lazy shim so @sentry/react ships as its
// own on-demand chunk instead of bloating the eager startup bundle.
import * as Sentry from "./lazy-sentry";

declare global {
  interface Window {
    SENTRY_RELEASE?: { id: string };
    SENTRY_DIST?: string;
  }
}

const sentryRelease = window.SENTRY_RELEASE;

if (sentryRelease) {
  let environment = "production";
  const { hostname } = window.location;
  if (/localhost/.test(hostname)) environment = "localhost";
  if (/staging/.test(hostname)) environment = "staging";
  if (/test/.test(hostname)) environment = "test";

  Sentry.init({
    dsn: "https://3c17c08030a97524499f9b2311503f33@o4509005379796992.ingest.de.sentry.io/4509005403258960",
    release: sentryRelease?.id,
    dist: window.SENTRY_DIST,
    environment,
  });
}
